import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AiChatService } from '../../appServices/ai-chat.service';
import { StoreResolver } from '../../appServices/store/store.resolver';
import { TokenService } from '../../auth/token.service';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.scss']
})
export class AiChatComponent implements OnInit {
  sessions: any[] = [];
  selectedSession: any;
  messages: any[] = [];
  chatForm: FormGroup;
  storeId: number;
  userId: number;

  constructor(
    private fb: FormBuilder,
    private aiChatService: AiChatService,
    private storeResolver: StoreResolver,
    private tokenService: TokenService
  ) {
    this.chatForm = this.fb.group({
      content: ['']
    });
  }

  ngOnInit(): void {
    this.storeResolver.selectedStore.subscribe(store => {
      if (store) {
        this.storeId = store.id;
        this.userId = this.tokenService.userId;
        this.loadSessions();
      }
    });
  }

  loadSessions() {
    this.aiChatService.getSessions(this.storeId, this.userId).subscribe(sessions => {
      this.sessions = sessions;
    });
  }

  createNewSession() {
    const title = 'New Chat'; // Or prompt for title
    this.aiChatService.createSession(this.storeId, this.userId, title).subscribe(session => {
      this.sessions.push(session);
      this.selectSession(session);
    });
  }

  selectSession(session: any) {
    this.selectedSession = session;
    this.loadMessages();
  }

  loadMessages() {
    this.aiChatService.getMessages(this.selectedSession.id).subscribe(messages => {
      this.messages = messages;
    });
  }

  sendMessage() {
    const content = this.chatForm.value.content;
    if (!content) return;
    this.aiChatService.sendMessage(this.selectedSession.id, content).subscribe(response => {
      this.messages.push({ role: 'user', content });
      this.messages.push(response);
      this.chatForm.reset();
    });
  }
}
